import { Typography } from '@mui/material';
import { Column, Row, Spacer } from '../../../components';

interface DescriptionSectionProps {
  description: string;
  art: React.ReactNode;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({ description, art }) => {
  return (
    <Row style={{ alignItems: 'center' }}>
      <Column style={{ width: '100%' }}>
        <Typography color='secondary' variant='p18SemiBold'>
          Description
        </Typography>
        <Spacer height='xxs' />
        <Typography color='info.main' variant='body1'>
          {description}
        </Typography>
      </Column>
      {art}
    </Row>
  );
};

export default DescriptionSection;
